import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Desktop } from '@breakpoints'
import Layout from '@organisms/layout'
import Text from '@particles/text'
import Heading from '@particles/heading'
import Link from '@atoms/link'
import Social from '@atoms/social'
import logoBlack from '@assets/logo-text-black.svg'
import { useStaticQuery, graphql } from 'gatsby'

const propTypes = {}

const FooterSite = styled.div`
  width: 100%;
  background: #2a2f3c;
  color: #515151;
  padding: 40px 0 10px;
`

const FooterCopyright = styled.div`
  width: 100%;
  background: #1d1d1d;
  color: white;
  padding: 1rem 0;
  line-height: 1.2rem;

  a {
    font-size: 0.8rem;
    color: white;
    text-decoration: none;
    margin: 0 0.25rem;
  }
`

const FooterContainer = styled.div`
  max-width: ${({ theme }) => theme.default.container}px;
  padding: 0 1rem;
  margin: auto;

  ${Desktop} {
    padding: 0 1rem;
  }

  a {
    color: #ffffff !important;
  }
`

const FooterComponent = ({ className }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            links {
              aboutKlipfolio
              legal
              security
              accessibility
            }
          }
        }
      }
    `
  )
  const links = site.siteMetadata.links
  return (
    <footer className={className}>
      <FooterSite>
        <FooterContainer>
          <Layout.Row
            margin="B1"
            wrap="true"
            justify="space-between"
            style={{ alignItems: 'flex-start' }}
          >
            <Layout.Column margin="L0 R1 T0 B1">
              <Layout.Column>
                <img
                  src={logoBlack}
                  width="150"
                  alt="MetricHQ Logo"
                  style={{ marginBottom: '0.75rem' }}
                />

                <Text size={1.25} color={'100'}>
                  Succeed with data.
                </Text>
              </Layout.Column>
            </Layout.Column>
            <Layout.Row wrap="true" justify="flex-start">
              <Layout.Column margin="L1 R1">
                <Heading h5 as={'h3'} margin="B0.5" color={'100'}>
                  Explore metrics
                </Heading>
                <Link to="/all-metrics">Browse by category</Link>
                <Link to="/all-services">Browse by service</Link>
                {/* <Link to="/">Browse by role</Link> */}
              </Layout.Column>
              <Layout.Column margin="L1 R1 T0">
                <Heading h5 as={'h3'} margin="B0.5" color={'100'}>
                  Get involved
                </Heading>
                <Link to="/contribute">Contribute a metric</Link>
                <Link to="/request">Request a metric</Link>
              </Layout.Column>
              <Layout.Column margin="L1 R1 T0">
                <Heading h5 as={'h3'} margin="B0.5" color={'100'}>
                  More about us
                </Heading>
                <Link to="/contributors">Our contributors</Link>
                <Link to="/mission">Our mission</Link>
                <Link to="/about">About MetricHQ</Link>
              </Layout.Column>
            </Layout.Row>
            <Layout.Row margin="L0 B1" justify="flex-start" center>
              <Layout.Column>
                <Link style={{ margin: 0 }} href="https://www.klipfolio.com/">
                  <Heading h4 as={'h3'} margin="B0.5" color={'100'}>
                    Klipfolio.com
                  </Heading>
                </Link>
                <Social.Row />
              </Layout.Column>
            </Layout.Row>
          </Layout.Row>
        </FooterContainer>
      </FooterSite>
      <FooterCopyright>
        <FooterContainer>
          <Layout.Row center wrap="true">
            <Text
              style={{ flex: 1, whiteSpace: 'nowrap' }}
              size={0.8}
              color={100}
            >
              Copyright © Klipfolio Inc. All Rights Reserved.
            </Text>
            <Link
              to="/legal"
              style={{ fontSize: '0.8rem', margin: '0 0.25rem' }}
            >
              Legal
            </Link>
            <a href={links.security}>Security</a>
            <a href={links.accessibility}>Accessibility</a>
          </Layout.Row>
        </FooterContainer>
      </FooterCopyright>
    </footer>
  )
}

FooterComponent.propTypes = {
  className: PropTypes.string
}

const Footer = styled(FooterComponent)`
  width: 100%;
  margin-top: 4rem;
  hr {
    width: 100%;
  }
  ${Link} {
    color: #515151;
    margin: 0.5rem 0;
    font-size: 0.9rem;
    :hover {
      text-decoration: underline;
    }
  }
`

Footer.propTypes = propTypes
export default Footer
